import React from 'react';

/**
 * Component BoxMessage
 * @param Object jsx props.content
 */
const BoxMessage = (props) => {
  /**
   * Rendu du module
   * @returns Object jsx
   */
  if(props.content) {
    return (
      <div className="mb-5">
        {props.content}
      </div>
    )
  } else {
    return null;
  }
}

export default BoxMessage;